/* Scentology — storefront behaviour */
(function () {
  'use strict';

  var money = window.Scentology && window.Scentology.moneyFormat ? window.Scentology.moneyFormat : 'LE {{amount}}';

  function formatMoney(cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return money.replace(/\{\{\s*amount\s*\}\}/, v);
  }

  /* ---------- drawers ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('[data-drawer-close]');
    if (f) f.focus();
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      e.preventDefault();
      openDrawer(document.getElementById(open.getAttribute('data-drawer-open')));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.hasAttribute('data-veil')) {
      var d = e.target.closest('.drawer');
      if (d) closeDrawer(d);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    }
  });

  /* ---------- sticky header ---------- */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-src');
        main.srcset = '';
        g.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var next = (parseInt(input.value, 10) || min) + parseInt(step.getAttribute('data-qty'), 10);
    input.value = Math.min(max, Math.max(min, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- cart drawer ---------- */
  var cartDrawer = document.getElementById('cart-drawer');

  function refreshCart() {
    return fetch(window.Scentology.routes.cart + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var body = cartDrawer && cartDrawer.querySelector('[data-cart-body]');
        if (!body) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-body]');
        if (fresh) body.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count-value]');
        if (count) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            var n = parseInt(count.textContent.trim(), 10) || 0;
            el.textContent = n;
            el.hidden = n === 0;
          });
        }
      });
  }

  /* add to cart */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-form]');
    if (!form || !cartDrawer) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = '…'; }

    fetch(window.Scentology.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{
          id: form.querySelector('[name=id]').value,
          quantity: parseInt((form.querySelector('[name=quantity]') || {}).value || 1, 10)
        }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return refreshCart().then(function () { openDrawer(cartDrawer); });
      })
      .catch(function (err) {
        var box = form.querySelector('[data-form-error]');
        if (box) { box.textContent = err.message; box.hidden = false; }
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = label; }
      });
  });

  /* change / remove line inside drawer */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-line-change]');
    if (!el) return;
    e.preventDefault();
    fetch(window.Scentology.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: el.getAttribute('data-line'),
        quantity: parseInt(el.getAttribute('data-line-change'), 10)
      })
    }).then(function () { return refreshCart(); });
  });

  window.Scentology = window.Scentology || {};
  window.Scentology.formatMoney = formatMoney;
  window.Scentology.refreshCart = refreshCart;
})();
